import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { phoneNumberValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  label?: string;
  labelRequired: boolean;
  annotationMessage?: string; // 注釈メッセージ
};

const PhoneNumberFormFieldMain = (
  { name, label = "電話番号", labelRequired, annotationMessage }: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          {label} {labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={name}
            registerOptions={{
              validate: phoneNumberValidation,
            }}
            maxLength={11}
            ref={ref}
          />
        </div>
        <div css={errorWrapper}>
          <FormErrorMessage name={name} />
        </div>
        <div css={validationRuleText}>
          <Font variant="s">
            半角スペース、ハイフンなしで入力してください
            {annotationMessage && (
              <>
                <br />
                {annotationMessage}
              </>
            )}
          </Font>
        </div>
      </div>
    </div>
  );
};

export const PhoneNumberFormField = React.forwardRef(PhoneNumberFormFieldMain);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const textFieldWrapper = css({
  maxWidth: "196px",
});

const errorWrapper = css({
  flex: 1,
});

const validationRuleText = css({
  marginTop: "10px",
  color: "#7E848E",
  fontSize: "12px",
});
